import { DisplayDate, DisplayDateProps, DisplayTime } from '@tock/time';
import { FunctionComponent } from 'react';
import { IconCalendar, IconClock } from '@tock/icons';
import { LocalDateTime } from 'js-joda';
import { Typography, TypographyProps } from 'omakase';
import { core } from '@tock/coretypes';

export interface ReservationDateAndTimeDetailProps {
  combineDateAndTime?: boolean;
  dateTime: LocalDateTime;
  isShipping?: boolean;
  purchaseCount?: number;
  showPurchaseCount?: boolean;
  showWeekday?: boolean;
  /**
   * optional weekday format to use when showWeekday is true.
   * defaults to long
   */
  displayWeekdayAs?: DisplayDateProps['displayWeekdayAs'];
  ticketTypeVariety?: core.TicketType.Variety;
  typographyVariant?: TypographyProps['variant'];
}

export const ReservationDateAndTimeDetail: FunctionComponent<ReservationDateAndTimeDetailProps> = ({
  combineDateAndTime = false,
  dateTime,
  isShipping = false,
  purchaseCount,
  showPurchaseCount = false,
  showWeekday = true,
  displayWeekdayAs = 'long',
  ticketTypeVariety,
  typographyVariant = 'body02',
}) => {
  const dateContent = (
    <DisplayDate
      dateValue={dateTime}
      displayMonthAs={showWeekday ? 'long' : 'short'}
      displayWeekdayAs={displayWeekdayAs}
      showWeekday={showWeekday}
    />
  );
  const timeContent = <DisplayTime timeValue={dateTime} />;
  const purchaseCountContent = showPurchaseCount && purchaseCount !== undefined && (
    <span> for {purchaseCount}</span>
  );

  return isShipping && ticketTypeVariety === 'ORDER_DELIVERY' ? (
    <li>
      <IconCalendar />
      <Typography component="span" variant={typographyVariant} color="fgDefault">
        Scheduled shipment for {dateContent}, {timeContent}
      </Typography>
    </li>
  ) : (
    <>
      <li>
        <IconCalendar />
        <Typography
          component="span"
          variant={typographyVariant}
          color="fgDefault"
          data-testid="reservation-date"
        >
          {dateContent}
          {combineDateAndTime && (
            <>
              {' '}
              at {timeContent}
              {purchaseCountContent}
            </>
          )}
        </Typography>
      </li>
      {!combineDateAndTime && (
        <li>
          <IconClock />
          <Typography
            component="span"
            variant={typographyVariant}
            color="fgDefault"
            data-testid="reservation-time"
          >
            {timeContent}
          </Typography>
        </li>
      )}
    </>
  );
};
